"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import * as THREE from "three";
import { vertexShader } from "../shaders/vertex";
import { fragmentShader } from "../shaders/fragment";
export default function EarthAtmosphere() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      atmOpacity: {
        value: 0.2
      },
      atmPowFactor: {
        value: 4.1
      },
      atmMultiplier: {
        value: 9.5
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const uniforms = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mesh><sphereGeometry /><shaderMaterial uniforms={uniforms} vertexShader={vertexShader} fragmentShader={fragmentShader} blending={THREE.AdditiveBlending} side={THREE.BackSide} depthWrite={false} /></mesh>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}